import React, { memo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface DateActionsProps {
    date: string;
    targetId?: string;
    selectedCell?: { day: string; targetId: string } | null;
    onCellSelect?: (cell: { day: string; targetId: string }, event?: React.MouseEvent) => void;
}

export const DateActions = memo(({ date, targetId, selectedCell, onCellSelect }: DateActionsProps) => {
    const { pathname } = useLocation();
    const history = useHistory();
    const { t } = useTranslation();

    const isSelected = selectedCell?.day === date && selectedCell?.targetId === targetId;

    const handleAddShiftForDate = (e: React.MouseEvent) => {
        e.stopPropagation();
        history.push(`${pathname}/new/${date}/${targetId ?? ""}`);
    };

    const handleCellClick = (e: React.MouseEvent) => {
        onCellSelect({ day: date, targetId }, e);
    };

    return (
        <div
            style={{
                backgroundColor: isSelected ? "rgba(33, 150, 243, 0.12)" : "transparent",
                border: "2px solid transparent",
                boxShadow: isSelected ? "0 0 0 1px #2196f3" : "none",
                display: "flex",
                alignItems: "center",
                padding: "4px",
                cursor: "pointer",
            }}
            onClick={handleCellClick}
        >
            <div
                onClick={handleAddShiftForDate}
                title={t("workShiftPlanning.newShift")}
                style={{
                    padding: "2px 6px",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "4px",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "#1976d2",
                }}
            >
                +
            </div>
            <div style={{ flex: 1 }} />
        </div>
    );
});